"use client"

import { cn } from "@/utils/classnames"
import clsx from "clsx"
import React, { useEffect, useState } from "react"

const SPINNER_VARIANTS = {
  small: {
    width: "w-[12.5px]",
    height: "h-[3px]",
  },
  medium: {
    width: "w-[20px]",
    height: "h-[5px]",
  },
  large: {
    width: "w-[25px]",
    height: "h-[6px]",
  },
} as const

export type SpinnerSize = keyof typeof SPINNER_VARIANTS

export interface SpinnerProps {
  delay?: number
  size?: SpinnerSize
  className?: string
}

/** Generic Spinner component */
export const Spinner: React.FC<SpinnerProps> = ({ delay = 0, size = "large", className, ...rest }) => {
  const [show, setShow] = useState(delay === 0)

  useEffect(() => {
    if (delay) {
      const timeout = setTimeout(() => {
        setShow(true)
      }, delay)
      return () => clearTimeout(timeout)
    }
    setShow(true)
  }, [delay])

  if (!show) return null

  const sizeClasses = SPINNER_VARIANTS[size]

  return (
    <div className={cn("absolute animate-spin bg-fg-1", sizeClasses.width, sizeClasses.height, className)} {...rest} />
  )
}
